<template>
  <page-list
    :list="list"
    :columns="templateListColumns || columns"
    :group-actions="groupActions"
    :single-actions="singleActions"
    :showSearchbox="showSearchbox"
    :export-data-options="exportDataOptions"
    :show-group-actions="showGroupActions"
    :show-single-actions="!isTemplate"
    :show-page="!isTemplate" />
</template>

<script>
import * as R from 'ramda'
import ListMixin from '@/mixins/list'
import WindowsMixin from '@/mixins/windows'
import { WORKFLOW_TYPES } from '@/constants/workflow'
import ResTemplateListMixin from '@/mixins/resTemplateList'
import GlobalSearchMixin from '@/mixins/globalSearch'
import ColumnsMixin from '../mixins/columns'
import SingleActionsMixin from '../mixins/singleActions'
import { getInternalResourceFilters } from '../../utils'

export default {
  name: 'ApprovalStartList',
  mixins: [WindowsMixin, ListMixin, GlobalSearchMixin, ColumnsMixin, SingleActionsMixin, ResTemplateListMixin],
  props: {
    id: String,
    listId: String,
    getParams: {
      type: Object,
    },
  },
  data () {
    const internalResourceFilters = getInternalResourceFilters()
    delete internalResourceFilters.end_time
    return {
      list: this.$list.createList(this, {
        id: this.listId || this.id,
        resource: 'process-tasks',
        apiVersion: 'v1',
        getParams: this.getParam,
        sortKeys: ['create_time'],
        filterOptions: {
          process_instance_id: {
            label: this.$t('common_350'),
          },
          ...internalResourceFilters,
        },
        genParamsCb: (params) => {
          return {
            ...params,
            details: false,
          }
        },
        hiddenColumns: ['alert_record_count', 'alert_info'],
      }),
      groupActions: [{
        label: this.$t('common_368'),
        action: () => {
          this.createDialog('WorkflowPassDialog', {
            vm: this,
            data: this.list.selectedItems,
            columns: this.columns,
            onManager: this.onManager,
            success: () => {
              this.refresh()
            },
          })
        },
        meta: () => {
          const ret = { validate: true }
          const pdkSet = new Set()
          const items = this.list.selectedItems
          if (!items.length) {
            ret.validate = false
            return ret
          }
          items.forEach(o => pdkSet.add(o.process_instance?.process_definition_key))
          if (pdkSet.size > 1) {
            ret.validate = false
            ret.tooltip = this.$t('system.workflow.tooltip.check_same_process_type')
            return ret
          }
          return ret
        },
      }, {
        label: this.$t('common_370'),
        action: () => {
          this.createDialog('WorkflowRejectDialog', {
            vm: this,
            data: this.list.selectedItems,
            columns: this.columns,
            onManager: this.onManager,
            success: () => {
              this.refresh()
            },
          })
        },
        meta: () => {
          const ret = { validate: true }
          const items = this.list.selectedItems
          if (!items.length) {
            ret.validate = false
            return ret
          }
          if (items.some(o => [WORKFLOW_TYPES.CUSTOMER_SERVICE, WORKFLOW_TYPES.ALERT_EVENT, WORKFLOW_TYPES.ALERT_TICKET].includes(o.process_instance.process_definition_key))) {
            ret.validate = false
            return ret
          }
          return ret
        },
      }],
    }
  },
  computed: {
    exportDataOptions () {
      return {
        downloadType: 'local',
        items: this.columns,
      }
    },
  },
  created () {
    this.initSidePageTab('approval-start-detail')
    this.list.fetchData()
  },
  methods: {
    getParam () {
      const ret = {
        ...(R.is(Function, this.getParams) ? this.getParams() : this.getParams),
        user_id: this.userInfo.id,
        process_definition_key_exclude: 'customer-service',
      }
      ret.filter = ret.filter ? (Array.isArray(ret.filter) ? ret.filter : [ret.filter]) : []
      if (ret.project_id) {
        ret.filter.push(`variables->project.equals(${ret.project_id})`)
        delete ret.project_id
      }
      if (ret.domain_id) {
        ret.filter.push(`variables->project_domain.equals(${ret.domain_id})`)
        delete ret.domain_id
      }
      return ret
    },
    handleOpenSidepage (row) {
      this.sidePageTriggerHandle(this, 'ApprovalStartSidePage', {
        id: row.id,
        resource: 'process-tasks',
        apiVersion: 'v1',
        getParams: this.getParam,
      }, {
        list: this.list,
      })
    },
  },
}
</script>
